import classNames from 'classnames';

import styles from './styles.module.scss';

export const CardTitle = (props: { title: string; children?: any }) => (
  <div className={classNames(styles.flexWrapper, styles.cardTitle)}>
    <h2 className={classNames(styles.trackingTitle, 'title-2')}>{props.title}</h2>
    {props.children}
  </div>
);
